import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { AuthService } from '../auth/auth.service';
import { HeaderService } from './header.service';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit {
  user;
  privilege;
  bmPage;
  bmStatus;
  public currentTime: Date = new Date();
  private timerId: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private headerServ: HeaderService,
  ) {}

  ngOnInit(): void {
    this.user = sessionStorage.getItem("usnm");
    if(this.user != null) this.privilege = true;
    let bookmark_link = localStorage.getItem('bookmark');
    if(this.router.url == bookmark_link) this.bmPage = 'samepage';
    else this.bmPage = 'notsamepage';

    if(bookmark_link != undefined) this.bmStatus = 'havelink';
    // this.stickyNavbar();
    // อัปเดตเวลาทุกๆ 1 วินาที
    this.timerId = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  }

  ngOnDestroy(): void {
    // หยุดการทำงานของ interval เมื่อ component ถูกทำลาย
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  stickyNavbar() {
    let height = $('.header-line-hight-top').height();
    $(window).scroll(function() {
      if (window.pageYOffset >= 25) {
        $(".bg-nav").addClass("fixed-top nav-fixedtop");
      } else {
        $(".bg-nav").removeClass("fixed-top nav-fixedtop");
      }
    });
  }

  public isSidenavOpen = false;
  toggleSidenav(): void {
    this.isSidenavOpen = !this.isSidenavOpen;
  }

  logOut() {
    this.privilege = false;
    this.authService.deauthen();
  }

  bookmark() {
    let pathBM = this.router.url;
    // console.log("pathBM:",pathBM);
    localStorage.setItem('bookmark',pathBM);
    this.headerServ.setFavorite(pathBM).subscribe(
      (res:any) => {
        // console.log("res : ",res);
        this.bmPage = 'samepage';
      },
      (error) => {
        console.log("error : ",error);
      }
    );
  }

  goto_bookmark() {
    let BMpath = localStorage.getItem('bookmark');
    window.location.href = "#"+BMpath;
  }

}
